import { Radio as InformedRadio, BaseFieldProps } from 'informed'
import React from 'react'

const Radio = (props: BaseFieldProps) => <InformedRadio {...props} />

export default Radio
